import { useIsWriteRestrictedUser } from "../../hooks/useIsWriteRestrictedUser";
import Input from "../Common/Input";
import Label from "../Common/Label";
import DropdownSelector from "../Common/DropdownSelector";
import ConfigUnitsImage from "../../assets/images/configUnit.png";

const SaveLocationDetails = ({
  selectedZone,
  setSelectedZone,
  selectedUnit,
  serialNumber,
  zoneList,
  selectedpropertie,
  selectedBuilding,
  updateFleetApi,
  setActiveLocationPage,
  handleGoBack,
  handleUnitNameChange,
  handleCreateZone,
  handleRemoveZone
}) => {
  const isActionsDisabled = useIsWriteRestrictedUser();

  return (
    <>
      {" "}
      <div className="flex-1 flex flex-col">
        <div className="flex w-full gap-6">
          <div className="flex gap-2 items-start border-b border-[#00000026] pb-5 grow">
            <div
              className="backIconHolder cursor-pointer hidden"
              onClick={handleGoBack}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M20 12H4M4 12L10 6M4 12L10 18"
                  stroke="#1E2A2C"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <h2 className="mainTitle text-[#000000DE] dark:text-white  font-semibold text-xl leading-5 lg:text-2xl lg:leading-6 tracking-[0.036px] ">
              Edit Unit
            </h2>
          </div>
        </div>
        <div className="flex gap-6 mt-6 items-start grow">
          <div className="formHolder grow w-full">
            <div className="w-full h-full">
              <div className="flex flex-col gap-y-6 lg:gap-y-8 h-full">
                <div>
                  <div className="flex items-start flex-col sm:flex-row gap-8 gap-y-4">
                    <div className="unitID_section gap-1 flex flex-col w-full sm:w-56 md:w-[272px]">
                      <div className="flex flex-col gap-1">
                        <Label
                          htmlFor="unitID"
                          className="text-dark-grey dark:text-white font-normal text-sm leading-4 xl:text-base lg:leading-5 tracking-[-0.24px]"
                        >
                          Serial Number
                        </Label>
                        <Input
                          id="unitID"
                          name="unit"
                          type="text"
                          placeholder="Enter Serial Number"
                          className="text-base leading-5 lg:text-lg xl:leading-6 py-2.5 px-3 rounded-md border border-[#AFC3BC] text-dark-grey h-11 bg-white placeholder:text-dark-grey/40 dark:darkThemeGradiantBg dark:border-none dark:text-white dark:placeholder:text-white/40 font-medium tracking-[-0.408px] outline-none opacity-40 pointer-events-none"
                          value={serialNumber ?? ""}
                          disabled
                          readOnly
                        />
                      </div>
                    </div>
                    <div className='basis-10 shrink-0 hidden sm:flex'></div>
                    <div className="flex items-center gap-4 w-full md:w-auto">
                      <div className="unitID_section gap-1 flex flex-col w-full">


                        <div className="flex flex-col gap-1">
                          <Label
                            htmlFor="unitName"
                            className="text-dark-grey dark:text-white font-normal text-sm leading-4 xl:text-base lg:leading-5 tracking-[-0.24px]"
                          >
                            Unit Name
                          </Label>
                          <div className="flex items-center gap-4">
                            <div className="w-full">
                              <Input
                                id="unitName"
                                data-testid="unitName-input"
                                type="text"
                                name="name"
                                value={selectedUnit?.metadata?.name ?? ""}
                                onChange={handleUnitNameChange}
                                placeholder="Enter Unit Name"
                                className={`text-base leading-5 lg:text-lg xl:leading-6 py-2.5 px-3 rounded-md border border-[#AFC3BC] text-dark-grey h-11 bg-white dark:darkThemeGradiantBg dark:border-none dark:text-white dark:placeholder:text-white/40 placeholder:text-dark-grey/40 font-medium tracking-[-0.408px] outline-none opacity-40 pointer-events-none w-full sm:w-56 md:w-[272px]`}
                              />
                            </div>
                          </div>
                          {selectedUnit?.metadata?.name === "" && (
                            <p className="text-critical text-xs leading-4">
                              Enter the unit name
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="locationDetails">
                  <div>
                    <h3 className="text-black dark:text-white text-lg leading-5 lg:text-xl lg:leading-6 font-semibold tracking-[0.03px]">
                      Location Details
                    </h3>
                    <div className="flex gap-1 mt-3 items-center w-full">
                      <div className="iconHolder">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          className="*:dark:stroke-white"
                        >
                          <path
                            d="M4 10.1433C4 5.64588 7.58172 2 12 2C16.4183 2 20 5.64588 20 10.1433C20 14.6055 17.4467 19.8124 13.4629 21.6744C12.5343 22.1085 11.4657 22.1085 10.5371 21.6744C6.55332 19.8124 4 14.6055 4 10.1433Z"
                            stroke="#292D32"
                            stroke-width="1.5"
                          />
                          <circle
                            cx="12"
                            cy="10"
                            r="3"
                            stroke="#292D32"
                            stroke-width="1.5"
                          />
                        </svg>
                      </div>
                      <p className="text-dark-grey dark:text-white text-base leading-5 lg:text-lg lg:leading-6 font-semibold tracking-[0.027px] w-3/4 truncate block">
                        {selectedpropertie?.name}
                        {selectedBuilding?.name ? `/${selectedBuilding?.name}` : ""}
                        {selectedUnit?.metadata?.unit ? `/${selectedUnit.metadata.unit}` : ""}
                        {selectedUnit?.metadata?.floor ? `/Floor-${selectedUnit.metadata.floor}` : ""}
                        {selectedUnit?.metadata?.room ? `/Room-${selectedUnit.metadata.room}` : ""}
                      </p>
                    </div>
                  </div>
                </div>
                <div className="podInfo h-full flex flex-col gap-12">
                  <div className="flex flex-col">
                    <h3
                      className="text-black dark:text-white text-lg leading-5 lg:text-xl lg:leading-6 font-semibold tracking-[0.03px]"
                      data-testid="edit-unit-zone-heading"
                    >
                      Assign to a Zone
                    </h3>
                    <p
                      className="text-dark-grey dark:text-[#AFC3BC] text-xs font-normal leading-4"
                      data-testid="edit-unit-zone-helper-text"
                    >
                      Add this unit to a Zone to complete configuration and enable full control.
                    </p>
                  </div>
                  <div className="h-full flex flex-col gap-10">
                    <DropdownSelector
                      options={zoneList}
                      onSelect={setSelectedZone}
                      sectionClass="Zone"
                      id="Zone"
                      name="Zone"
                      placeholder="Select a Zone"
                      defaultValue={selectedZone}
                      addClick={handleCreateZone}
                      handleRemoveZone={handleRemoveZone}
                      zoneSelectDropDown={true}
                      disabled={isActionsDisabled}
                      data-testid="edit-unit-zone-dropdown"
                    />
                  </div>
                  <div className="actionsHolder flex items-center gap-6 max-[530px]:justify-center justify-between flex-wrap lg:gap-10 w-full">
                    <div className="flex items-center gap-6 justify-center sm:justify-start">
                      <button
                        data-testid="edit-unit-save-button"
                        onClick={
                          selectedUnit?.metadata?.name?.trim() === ""
                            ? (e) => { e.preventDefault() }
                            : () => {
                                if (isActionsDisabled) return;
                                updateFleetApi();
                              }
                        }
                        className={`${(selectedUnit?.metadata?.name === "" || isActionsDisabled) &&
                          "bg-theme/80 cursor-not-allowed opacity-60"
                          }  bg-theme text-white h-10 rounded-md text-sm leading-4 lg:text-base lg:leading-5 font-semibold tracking-[-0.32px] px-5 py-3 flex items-center justify-center basis-36 shrink-0 grow-0 hover:bg-theme/80`}
                        disabled={selectedUnit?.metadata?.name?.trim() === "" || isActionsDisabled}
                      >
                        Save
                      </button>
                      <button
                        className="bg-white dark:bg-transparent hover:bg-theme dark:hover:bg-theme dark:text-theme hover:text-white dark:hover:text-white transition border border-theme text-theme h-10 rounded-md text-sm leading-4 lg:text-base lg:leading-5 font-semibold tracking-[-0.32px] px-5 py-3 flex items-center justify-center basis-36 shrink-0 grow-0"
                        onClick={handleGoBack}
                      >
                        Cancel
                      </button>
                    </div>
                    <button
                      className="bg-white dark:bg-transparent hover:bg-theme dark:hover:bg-theme dark:text-theme hover:text-white dark:hover:text-white transition border border-theme text-theme h-10 rounded-md text-sm leading-4 lg:text-base lg:leading-5 font-semibold tracking-[-0.32px] px-5 py-3 flex items-center justify-center basis-36 shrink-0 grow-0"
                      onClick={() => setActiveLocationPage(true)}
                    >
                      Back
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="imageHolder basis-[424px] hidden lg:flex justify-end h-[calc(100vh-185px)]">
            <img
              src={ConfigUnitsImage}
              alt="configUnit"
              className="object-cover dark:rounded-lg"
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default SaveLocationDetails;
